import React from "react";
import additionalfn from "../../_additionalfn";
import withTranslator from "../Translator/withTranslation";

class VillaTileIconsComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    

    iconsData(){
        const { t } = this.props;
        var internetLabel = !this.props.data.internet && !this.props.data.freeinternet ? 
                            t('no') : 
                            (this.props.data.freeinternet ? t('free') : t('wifi'));
    
        const data = [
            {
                label: this.props.data.maxSleeps,
                image: '/assets/img/front/icons/people-two-blue1.svg',
                show: true,
                width: 17
            },
            {
                label: additionalfn.mToKm(this.props.data.distanceBeach),
                image: '/assets/img/front/icons/beach-blue1.svg',
                show: true,
                width: 20
            },
            {
                label: (this.props.data.poolType == 'private') ? t('private') : t('yes'),
                image: '/assets/img/front/icons/pool-lader-blue1.svg',
                show: (this.props.data.poolType == 'none') ? false : true,
                width: 20
            },
            {
                label: internetLabel,
                image: '/assets/img/front/icons/wifi-blue1.svg',
                show: true,
                width: 25
            }, 
            {
                label: this.props.data.numBedrooms,
                image: '/assets/img/front/icons/bed-side-blue1.svg',
                show: true,
                width: 25
            },
            {
                label: this.props.data.numBathrooms,
                image: '/assets/img/front/icons/bathroom-blue1.svg',
                show: true,
                width: 25
            }
        ];
        
        return data;
    }
    
    render() {
        const iconsData = this.iconsData();

        return (
            <div className={this.props.className}>
                {iconsData.map((item, index) => {
                return item.show ? ( <div key={index} >
                    <img src={item.image} height={this.props.iconHeight} width={item.width} alt="icon"/>
                    <div className="ucfirst">{item.label}</div>
                </div> ) : '';
                })}
            </div>
        );
    }
}

export const VillaTileIcons = withTranslator(VillaTileIconsComponent);